import { RelatedCategoriesResponseModel } from './types';
import { TEMPLATES_REQUEST_LIMIT } from '../pages/Categories/constants';

export default async function getTemplateNavigationLinks(
  category: string,
  subCategory: string,
  headers?: any,
): Promise<RelatedCategoriesResponseModel> {
  const subCategoryPart = subCategory ? `${subCategory}/` : '';
  const sourceUrl = `${process.env.REACT_APP_MAIN_DOMAIN}/templates/${category}/${subCategoryPart}`;

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify({
      sourceUrl,
      limit: TEMPLATES_REQUEST_LIMIT,
    }),
  };

  const url = `${process.env.REACT_APP_API_URL}/growth-utilities/v1/navigationLinks/groups/filter`;
  const res = await fetch(url, options);

  if (!res.ok) {
    throw new Error(`Status error fetching ${url}: ${res.status}`);
  }

  return res.json();
}
